/**
 * Saisie clavier des dates au format français : 31/12/2028, 31-12-2028, 31.12.2028,
 * 31122028 ou 31/12/28 (siècle 2000). Renvoie la date ISO `YYYY-MM-DD`, ou null si la
 * date n'existe pas. Le format ISO est aussi accepté.
 */
export function parseFrenchDate(value: string): string | null {
  const text = value.trim();
  const iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(text);
  const fr = /^(\d{1,2})[/.-](\d{1,2})[/.-](\d{2}|\d{4})$/.exec(text);
  const compact = /^(\d{2})(\d{2})(\d{4})$/.exec(text);
  let day: number;
  let month: number;
  let year: number;
  if (iso) {
    [year, month, day] = [Number(iso[1]), Number(iso[2]), Number(iso[3])];
  } else if (fr ?? compact) {
    const m = (fr ?? compact)!;
    [day, month, year] = [Number(m[1]), Number(m[2]), Number(m[3])];
    if (m[3]!.length === 2) year += 2000;
  } else {
    return null;
  }
  const date = new Date(Date.UTC(year, month - 1, day));
  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  ) {
    return null;
  }
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}
